import ReferFriendModal from "components/CustomWidgets/referFriendModal";
import React, { createContext, useContext, useState } from "react";

const ReferModalContext = createContext();

export function ReferModalProvider({ children }) {
  const [referOpen, setReferOpen] = useState(false);
  return (
    <ReferModalContext.Provider value={{ referOpen, setReferOpen }}>
      {children}
      <ReferFriendModal />
    </ReferModalContext.Provider>
  );
}

export function useReferModal() {
  return useContext(ReferModalContext);
}
